import { GlobalConstants } from "../data/GlobalConstants";
import { handleResponse } from "../util/functions";
import { getToken } from "../helpers/helperJWT";
import { loaderService } from "./loaderService";

const url = GlobalConstants.urlApi;

export const rezonificacionServices = {
    getRegistroRezonificacion,
    getAgenteByUsuario,
    getRuteroByAgente,
    validarExcel,
    setSolicitudesRezonificacion,
    validarBtnCargaMasiva
}

function getRegistroRezonificacion(){
    loaderService.showLoader({label: 'Cargando...'})

    const requestOptions = {
        method: 'POST',
        headers:{
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({})
    }

    return fetch(`${url}/rezonificacion/getRegistroRezonificacion`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
}

function getAgenteByUsuario(){
    loaderService.showLoader({label: 'Cargando...'})

    const requestOptions = {
        method: 'POST',
        headers:{
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({})
    }

    return fetch(`${url}/rezonificacion/getAgenteByUsuario`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
}

function getRuteroByAgente(data){
    loaderService.showLoader({label: 'Cargando...'})

    const requestOptions = {
        method: 'POST',
        headers:{
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    }

    return fetch(`${url}/rezonificacion/getRuteroByAgente`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
}

function validarExcel(data){
    loaderService.showLoader({label: 'Cargando...'})

    const requestOptions = {
        method: 'POST',
        headers:{
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    }

    return fetch(`${url}/rezonificacion/validarExcel`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
}

function setSolicitudesRezonificacion(data, file){
    loaderService.showLoader({label: 'Cargando...'})

    const formData = new FormData();

    formData.append('data', JSON.stringify(data));
    formData.append('app', 'maestros');
    formData.append('interface', 'Rezonificacion');
    formData.append('EXCEL', file);

    const requestOptions = {
        method: 'POST',
        headers:{
            'Authorization': getToken()
        },
        body: formData
    }

    return fetch(`${url}/rezonificacion/setSolicitudesRezonificacion`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
}

function validarBtnCargaMasiva(){
    loaderService.showLoader({label: 'Cargando...'})

    const requestOptions = {
        method: 'POST',
        headers:{
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({})
    }

    return fetch(`${url}/rezonificacion/validarBtnCargaMasiva`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
}
